import { useSelector } from "react-redux";
import { isEmpty } from "lodash";

export function useCmsAuth() {
  const auth = useSelector((state) => state.user.userDetails);
  const token = isEmpty(auth) ? null : auth.token;
  return { token };
}
